import React from "react";

function safeHref(url) {
  if (!url) return "";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
}

export default function BusinessHeader({
  businessName,
  businessAddress,
  phone,
  email,
  website,
  documentTitle,
  documentNumber,
  issueDate,
  dueDate,
  status,
}) {
  const websiteHref = safeHref(website);

  return (
    <div className="jt-document-section jt-doc-business-header">
      <div className="jt-doc-brand-block">
        <div>
          <div className="jt-doc-business-name">
            {businessName || "Your Company"}
          </div>

          {businessAddress && (
            <div className="jt-doc-business-address">
              {businessAddress}
            </div>
          )}

          <div className="jt-doc-contact-line">
            {phone && <span><b>Phone:</b> {phone}</span>}
            {email && <span><b>Email:</b> {email}</span>}
            {website && (
              <span>
                <b>Website:</b>{" "}
                <a href={websiteHref} target="_blank" rel="noopener noreferrer">
                  {website}
                </a>
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="jt-doc-meta-card">
        <div className="jt-doc-title">{documentTitle || "DOCUMENT"}</div>

        <div className="jt-doc-meta-grid">
          {documentNumber && (
            <>
              <div>No.</div>
              <strong>{documentNumber}</strong>
            </>
          )}

          {issueDate && (
            <>
              <div>Issue Date</div>
              <strong>{issueDate}</strong>
            </>
          )}

          {dueDate && (
            <>
              <div>Due Date</div>
              <strong>{dueDate}</strong>
            </>
          )}

          {status && (
            <>
              <div>Status</div>
              <strong>{status}</strong>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
